import { Component, OnInit } from '@angular/core';
import { CXMCustomerAddressResponse } from 'src/app/core/models/CXMCustomerAddressResponse';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { UserService } from 'src/app/core/user/user.service';
import { ChannelService } from 'src/app/home/channel/channel.service';

@Component({
  selector: 'app-manage-address',
  templateUrl: './manage-address.component.html',
  styleUrls: ['./manage-address.component.scss']
})

export class ManageAddressComponent implements OnInit {
  savedAddress: CXMCustomerAddressResponse[] = [];

  constructor(
    private userService: UserService,
    private channelService: ChannelService,
    private navigationService: NavigationService,
  ) { }

  async ngOnInit() {
    await this.channelService.getChannelDataCheck();
    this.savedAddress = await this.userService.getCustomerAddress(this.channelService?.getChannelId());
  }

  editSelectedAddress(address: CXMCustomerAddressResponse) {
    this.userService.setEditAddress(address);
    this.navigationService.navigate(['account', 'address', 'edit-address']);
  }

  onClickBack(){
    this.navigationService.navigate(['profiles']);
  }
}
